const l = {
  1: "large-12",
  2: "large-6",
  3: "large-4",
  4: "large-3"
}, e = {
  1: "small-12",
  2: "small-12",
  3: "small-12",
  4: "small-6"
};
function a(s) {
  return !s || s > 4 ? "" : `${l[s] ?? ""} ${e[s] ?? ""} columns`;
}
export {
  a as getResponsiveClasses
};
